$(function () {
  "use strict";

  var _this,
    _window = $(window);

  /**
   * NEWSの高さとFacebookの高さを揃える
   */
  $(function () {
    var articles = $("#index .news__articles"),
      articlesHeight = articles.height(),
      facebookWrapper = $("#index .news__facebook .fb-page");

    if (_window.width() > 1199) {
      facebookWrapper.attr("data-height", articlesHeight);
    } else {
      facebookWrapper.attr("data-width", 500);
    }
  });

  $(".js-word").lettering("lines");

  /**
   * flickity
   */
  var $indexCarouselSlider = $("#index-carousel-slider");

  if ($indexCarouselSlider) {

    /**
     * Topページのスライダーが初期読み込み時に縦並びになるのを解消する
     */
    var slideStartClassName = "-start";
    var topSlider = document.getElementById("js-top-slider");

    $indexCarouselSlider.on("ready.flickity", function () {
      // console.log("Flickity ready");
      topSlider.classList.add(slideStartClassName);
    });

    $indexCarouselSlider.flickity({
      cellAlign: "left",
      contain: true,
      draggable: true,
      wrapAround: true,
      autoPlay: 3000,
      prevNextButtons: true,
      adaptiveHeight: true,
    });
  }
});
